<div class="he-root" [class.disabled]="disabled">
  <div class="he-sticky">
    <div class="he-toolbar">
      @if (!simple) {
        <select class="he-select" [disabled]="disabled" (change)="setTextStyle($any($event.target).value)">
          <option value="display">display</option>
          <option value="heading-1">heading-1</option>
          <option value="heading-2">heading-2</option>
          <option value="heading-3">heading-3</option>
          <option value="subtitle-1">subtitle-1</option>
          <option value="body">body</option>
          <option value="caption">caption</option>
          <option value="links">links</option>
        </select>

        <div class="he-sep"></div>
      }

      <button type="button" class="he-btn" [disabled]="disabled" (click)="bold()"><b>B</b></button>
      <button type="button" class="he-btn" [disabled]="disabled" (click)="italic()"><i>I</i></button>

      @if (!simple) {
        <select
          class="he-select"
          [disabled]="disabled"
          (change)="setTextColor($any($event.target).value); $any($event.target).value = ''"
          id="elux-colors"
        >
          <option value="">cor</option>
          @for (c of textColorOptions; track c.label) {
            <option
              [value]="c.value"
              [style]="{
                color: c.label === 'white' ? 'white' : c.value,
                'background-color': c.label === 'white' ? '#a0a0a0' : 'transparent',
              }"
            >
              {{ c.label }}
            </option>
          }
        </select>

        <button type="button" class="he-btn" [disabled]="disabled" (click)="createLink()" title="Link">🔗</button>
        <button type="button" class="he-btn" [disabled]="disabled" (click)="unlink()" title="Remover link">⛓️‍💥</button>

        <div class="he-sep"></div>

        <button
          type="button"
          class="he-btn"
          [disabled]="disabled"
          (mousedown)="$event.preventDefault()"
          (click)="bulletList()"
          title="Lista"
        >
          •≡
        </button>
        <button
          type="button"
          class="he-btn"
          [disabled]="disabled"
          (mousedown)="$event.preventDefault()"
          (click)="orderedList()"
          title="Lista numerada"
        >
          1≡
        </button>

        <div class="he-sep"></div>

        <button type="button" class="he-btn" [disabled]="disabled" (click)="alignLeft()" title="Esquerda">⟸</button>
        <button type="button" class="he-btn" [disabled]="disabled" (click)="alignCenter()" title="Centro">≡</button>
        <button type="button" class="he-btn" [disabled]="disabled" (click)="alignRight()" title="Direita">⟹</button>

        <button
          type="button"
          class="he-btn"
          [disabled]="disabled"
          (mousedown)="$event.preventDefault()"
          (click)="openImagePanel()"
          title="Imagem"
        >
          🖼️
        </button>
        <button type="button" class="he-btn" [disabled]="disabled" (click)="insertTable()" title="Tabela">▦</button>

        <div class="he-sep"></div>

        <button type="button" class="he-btn" [disabled]="disabled" (click)="undo()" title="Desfazer">↶</button>
        <button type="button" class="he-btn" [disabled]="disabled" (click)="redo()" title="Refazer">↷</button>

        <div class="he-spacer"></div>

        <button type="button" class="he-btn danger" [disabled]="disabled" (click)="clear()" title="Limpar">🗑️</button>
      }
    </div>

    <div class="he-image-panel" *ngIf="showImagePanel">
      <div class="he-select-file mb-4">
        <div>
          <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" hidden />
          <button type="button" class="he-btn" [disabled]="disabled || uploadingImage" (click)="onPickFileClick()">
            {{ editingImage ? 'Trocar imagem' : 'Selecionar imagem' }}
          </button>
          <div class="ps-1 mb-3">
            <span class="he-file" *ngIf="pendingFile as f">{{ f.name }}</span>
            <span class="he-file muted" *ngIf="!pendingFile">
              {{ editingImage ? 'Mantendo a imagem atual' : 'Nenhuma imagem selecionada' }}
            </span>
          </div>
        </div>

        <div class="he-dimensions">
          <label>
            Largura
            <br />
            <input class="he-input" type="text" [(ngModel)]="imageWidth" [disabled]="uploadingImage" />
            <span>
              px ou %, padrão "100%"
              <br />
              ex.: 100px
            </span>
          </label>

          <label>
            Altura
            <br />
            <input class="he-input" type="text" [(ngModel)]="imageHeight" [disabled]="uploadingImage" />
            <span>
              px ou %, padrão "auto"
              <br />
              ex.: 20%
            </span>
          </label>

          <label>
            Texto alternativo (alt)
            <br />
            <input class="he-input he-input-alt" type="text" [(ngModel)]="imageAlt" [disabled]="uploadingImage" />
            <span>
              descreva o conteúdo da imagem
              <br />
              &nbsp;
            </span>
          </label>

          <label>
            Posição
            <br />
            <select class="he-select" [(ngModel)]="imageAlign" [disabled]="uploadingImage">
              @for (a of imageAlignOptions; track a.value) {
                <option [value]="a.value">{{ a.label }}</option>
              }
            </select>
            <span>
              visível com largura menor que 100%
              <br />
              &nbsp;
            </span>
          </label>
        </div>
      </div>

      <div class="he-image-actions">
        <button type="button" class="he-btn" [disabled]="disabled || uploadingImage" (click)="confirmImagePanel()">
          <span *ngIf="!uploadingImage">{{ editingImage ? 'Salvar' : 'Inserir' }}</span>
          <span *ngIf="uploadingImage">Enviando...</span>
        </button>

        <button type="button" class="he-btn" [disabled]="disabled || uploadingImage" (click)="closeImagePanel()">
          Cancelar
        </button>
      </div>

      <div class="he-error" *ngIf="uploadError">{{ uploadError }}</div>
    </div>
  </div>

  <div
    #editor
    class="he-editor"
    [attr.contenteditable]="!disabled"
    (keydown)="onKeyDown($event)"
    (paste)="onPaste($event)"
    (input)="onInput()"
    (click)="onEditorClick($event)"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    (blur)="onBlur()"
    [attr.data-placeholder]="placeholder"
  ></div>
</div>
